export const Environment = {
  production: true,
  assetsUrl: 'https://www.utiliportal.com',
  serverPath: 'https://wa.utiliportal.com',
  quaditPath: "https://wa.utiliaudit.com",
  utmeterPath: "https://wa.utilimeter.com",
};